import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { getLocaleFromPath } from "../../i18n/config";
import { metadataTranslations } from "../../i18n/metadata";
import StepsHeader from "../../components/StepsHeader";
import { AppState } from "../../redux/types";
import { categoryOptions } from "../../utils/constants";
import styles from "./thanks.module.css";

export default function Thanks() {
    const category = useSelector((state: AppState) => state.categories.category?.attributes.slug);
    const locale = getLocaleFromPath();
    const meta = metadataTranslations.thanks[locale] || metadataTranslations.thanks.fi;

    const getMessageByCategory = () => {
        switch (category) {
            case categoryOptions.accessories:
                return "Saat sähköpostiin maksulinkin ja tilausvahvistuksen.Tuotteiden toimitusaika on yleensä 1–2 viikkoa.";
            case categoryOptions.alarm:
                return "Saat sähköpostiin tilausvahvistuksen ja tietoa palvelun käyttöönotosta. Tuotteiden toimitusaika on yleensä 1-2 viikkoa.";
            default:
                return "Saat sähköpostiin tilausvahvistuksen ja tietoa palvelun käyttöönotosta. Tuotteiden toimitusaika on yleensä 1-2 viikkoa.";
        }
    };

    return (
        <div>
            <Helmet>
                <title>{meta.title}</title>
                <meta name="description" content={meta.description} />
                <meta name="robots" content="noindex, follow" />
            </Helmet>
            <StepsHeader step1 step2 step3 step4 step5 />
            <div className={styles.container}>
                <h2 className={styles.header}>Tilauksesi on valmis!</h2>
                <p className={styles.message}>{getMessageByCategory()}</p>
                <p className={styles.note}>Huom! Jos käytät Gmail-osoitetta, tarkastathan myös "Tarjoukset" ("Promotions") kansion.</p>
            </div>
        </div>
    );
}
